angular.module('shbdeployer.integrations', ['shbdeployer.integrations.storidge']);
